import React, { useState } from 'react'
import './content.scss'
import Image1 from './img/vas-image.svg'
import Image2 from './img/vas-image-2.svg'
import Image3 from './img/vas-image-3.svg'
import Image4 from './img/vas-image-4.svg'
import Image5 from './img/vas-image-5.svg'

export default function EmeraldValueAddedSection() {
  const [activeCategory, setActiveCategory] = useState(null)

  const changeActiveCategory = newCategory => {
    if (activeCategory?.title === newCategory?.title) {
      if (window.innerWidth < 768) {
        setActiveCategory(null)
      }
      return
    }
    setActiveCategory(newCategory)
  }

  const valueAddedBoxesData = [
    {
      title: 'Logistics That Goes The Distance',
      description:
        'Multiple distribution centers, leveraging cutting-edge software, gets you products delivered FASTER and ahead of schedule.',
      image: Image1,
    },
    {
      title: 'Total End-to-End Solutions for Healthcare Facilities',
      description:
        'From unrivaled product availability, custom shipping solutions, along with, 3PL services, we can help you deliver better care.',
      image: Image2,
    },
    {
      title: 'An Individual Hands-On Approach Navigating Contracts',
      description:
        'Proprietary technologies to identify your ideal GPO fit and integrate within just 24 hours.',
      image: Image3,
    },
    {
      title: 'Medical Supplies, Pharmaceuticals, Equipment, and Vaccines',
      description:
        'We are authorized distributors for nearly 300 brands. We only sell guaranteed authentic and warrantied products, so you never have to worry about a thing.',
      image: Image4,
    },
    {
      title: 'From Healthcare Facilitates to Omnichannel we Give You an Edge',
      description:
        'We sell everywhere and give you unmatched product selection and access to products not available elsewhere.',
      image: Image5,
    },
  ]

  const ValueAddedBox = ({ data, index }) => {
    return (
      <div
        className={`vas__btn ${
          activeCategory
            ? activeCategory.title == data.title
              ? 'active'
              : ''
            : index === 0 && 'active'
        }`}
      >
        <div className="vas__box-link">
          <div className="vas__box" onClick={() => changeActiveCategory(data)}>
            <h4 className="vas__box-title">{data.title}</h4>
            <p className="vas__box-desc">{data.description}</p>
          </div>
        </div>
      </div>
    )
  }

  const ValueAddedImage = ({ data, index }) => {
    return (
      <div
        className={`vas__body ${
          activeCategory
            ? activeCategory.title == data.title
              ? 'active'
              : ''
            : index === 0 && 'active'
        }`}
      >
        <div className="vas__image">
          <img src={data.image} alt={data.title} loading="lazy" />
        </div>
      </div>
    )
  }

  return (
    <div className="vas">
      <div className="container">
        <div className="vas__block">
          <div className="vas__titles">
            <h2 className="vas__title">Value-Add Solutions</h2>
            <p className="vas__desc">With Dealmed your success is prescribed.</p>
          </div>

          <div className="vas__boxes">
            {valueAddedBoxesData.map((data, index) => (
              <ValueAddedBox key={index} data={data} index={index} />
            ))}
          </div>

          <div className="vas__content">
            {valueAddedBoxesData.map((data, index) => (
              <ValueAddedImage key={index} data={data} index={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
